import React, { useState} from "react";
import Modal from "react-bootstrap/Modal";
import { CONTENT_HEADING } from "../../constants";
import Content from "../global/Content";
import { useNavigate,Link } from "react-router-dom";


const Publishing = () => {
	return (
		<>
		<Content title="What We Publish">
			<p className='pera-text publishplatform tagp'>
				Aakashganga Open publishes scholarly work across its Mega Journals and participating Society, University and Institute Journals.
			</p>
			<p className='pera-text tagp'>
				We currently accept:
			</p>
			<ul className="tagul">
				<li className="tagli">Original research articles</li>
				<li className="tagli">Review articles and systematic reviews</li>
				<li className="tagli">Case reports</li>
				<li className="tagli">Methodology articles</li>
				<li className="tagli">Data articles</li>
				<li className="tagli">Conceptual articles</li>
				<li className="tagli">Perspectives and opinion articles</li>
				<li className="tagli">Commentaries</li>
				<li className="tagli">Book reviews</li>
				<li className="tagli">Mini reviews</li>
			</ul>
			<p className='pera-text tagp'>
				Article types available may vary by journal and review model. Authors should select the journal and article type that best match the manuscript.
			</p>
		</Content>
		</>
	);
};

export default Publishing;
